module.exports = __webpack_public_path__ + "static/media/app-store.671cd61a.png";